import { asHintId, type Hint } from '@/shared/stores';

import { PATIENT_SNAPSHOT_TAB_ANCHOR } from './anchors';

// Anchor only mounts in the snapshot success branch, so the hint waits for real content.
export const patientSnapshotHint: Hint = {
  id: asHintId('patient-workspace:snapshot'),
  version: 1,
  priority: 70,
  anchor: PATIENT_SNAPSHOT_TAB_ANCHOR,
  copy: {
    title: 'Patient at a glance',
    body: 'Demographics, insurance, allergies, and key facts in one place. The snapshot is your source of truth before charting or messaging.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
